import React, { useState, useContext } from 'react';
import { Button, DialogActions, Grid, TextField, MenuItem, IconButton, } from '@mui/material';
import styles from './styles.module.css';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import TableService from 'services/TableService';
import Loader from 'components/utils/Loading';
import { AlertMessagesContext } from 'react-alert-messages';
import NumberField from 'components/library/NumberField';
import { useTranslation } from 'react-i18next';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#afcdf0' : '#afcdf0',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function TableDetailsDialog({ table, handleClose, handleSuccess, areas }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState(table);
  const [chair, setChair] = useState('');
  const [area, setArea] = useState(table.area);

  const { postAlertMessage } = useContext(AlertMessagesContext);

  const handleActionButton = async () => {
    if (area === null) {
      postAlertMessage({ text: tPopup('Please select as area'), type: 'failed' });
      return;
    }
    setLoading(true);
    try {
      const payload = {
        name: data.name,
        order: data.order,
        area_id: area.id,
        chairs: data.chairs,
      };
      await TableService.updateTables(data.id, payload);
      postAlertMessage({ text: tPopup('Table updated successfully'), type: 'success' });
      await handleSuccess();
    } catch (error) {
      postAlertMessage({ text: error?.message, type: 'failed' });
      handleClose();
    }
    setLoading(false);
  };

  const onAddChairClicked = () => {
    data.chairs ||= [];
    data.chairs.push({ name: chair });
    setChair('');
  };

  return (
    <>
      <Loader isOpen={isLoading} />
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Table Details')}</h2>
            <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
          </div>
          <div className={styles.inputSec}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item sm={4} xs={4}>
                <h6 className={styles.tableName}>{tCommon('Table Name')}</h6>
              </Grid>
              <Grid item sm={8} xs={8}>
                <TextField
                  label={tCommon('Table Name')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="text"
                  defaultValue={data.name}
                  onChange={(e) => {
                    setData({ ...data, name: e.target.value });
                  }}
                />
              </Grid>
              <Grid item sm={4} xs={4}>
                <h6 className={styles.tableName}>{tCommon('Order')}</h6>
              </Grid>
              <Grid item sm={8} xs={8}>
                <NumberField
                  label={tCommon('Order')}
                  value={data.order}
                  onChange={(e) => {
                    setData({ ...data, order: Number(e.target.value) });
                  }}
                />
              </Grid>
              <Grid item sm={4} xs={4}>
                <h6 className={styles.tableName}>{tCommon('Area')}</h6>
              </Grid>
              <Grid item sm={8} xs={8}>
                <TextField
                  select
                  label={tCommon('Select Area')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={area?.id || ''}
                  onChange={(e) => {
                    const selectedArea = areas.find((a) => a.id === Number(e.target.value));
                    setArea(selectedArea);
                  }}
                >
                  {areas.map((a) => (
                    <MenuItem key={a?.id} value={a?.id}>
                      {a.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
            {(data.chairs || []).map((chair, index) => (
              <Grid container className={styles.inputData} alignItems="center" marginTop={2}>
                <Grid item sm={4} xs={4} justify="flex-end" className={styles.inputLabelContainer}>
                  <h6 className={styles.tableName}>{`Chair ${index + 1}`}</h6>
                </Grid>
                <Grid item sm={7} xs={7}>
                  <Item>{chair.name} </Item>
                </Grid>
                <Grid item xs={1} sm={1} display="flex" justifyContent="center">
                  <IconButton edge="end" aria-label="delete">
                    <DeleteIcon
                      onClick={() => {
                        data.chairs.splice(index, 1);
                        setData({
                          ...data,
                          chairs: data.chairs,
                        });
                      }}
                    />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
            <Grid container className={styles.inputData} style={{ marginTop: 10 }} alignItems="center">
              <Grid item xs={4} sm={4}>
                <h6 className={styles.tableName}>{tCommon('New Chair')}</h6>
              </Grid>
              <Grid item xs={7} sm={7}>
                <TextField
                  label={tCommon('New Chair')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={chair}
                  type="text"
                  onChange={(e) => {
                    setChair(e.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={1} sm={1} display="flex" justifyContent="center">
                <IconButton edge="end" aria-label="delete">
                  <LibraryAddIcon onClick={onAddChairClicked} disabled={!data.chair} />
                </IconButton>
              </Grid>
            </Grid>
          </div>
          <div className={styles.footSec}>
            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                disabled={!data.name}
                onClick={handleActionButton}
              >
                {tCommon('Update')}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
